"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RFormItem = exports.RFormInputItem = exports.FormItem = exports.FormInputItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reduxForm = require("redux-form");
require("./FormItem.css");
var _excluded = ["children", "size"],
  _excluded2 = ["component"],
  _excluded3 = ["input", "meta", "label", "className", "layout"],
  _excluded4 = ["component", "size"],
  _excluded5 = ["input", "meta", "label", "className", "layout"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var FormItem = exports.FormItem = function FormItem(_ref) {
  var label = _ref.label,
    error = _ref.error,
    children = _ref.children,
    className = _ref.className,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'vertical' : _ref$layout;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('form-item--wrapper', "form-item--wrapper__".concat(layout), className)
  }, !!label && /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-item--field"
  }, children, error && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-item--error-message"
  }, error)));
};

/**
 * @param {object} props
 * @param {'small'|'default'|'large'} props.size
 */
var FormInputItem = exports.FormInputItem = function FormInputItem(_ref2) {
  var children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(FormItem, props, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('form-item form-item--input', "form-item--".concat(size), !!props.error && 'form-item--error')
  }, children));
};
var RFormItem = exports.RFormItem = function RFormItem(_ref3) {
  var Component = _ref3.component,
    props = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    component: (0, _react.useCallback)(function (_ref4) {
      var input = _ref4.input,
        meta = _ref4.meta,
        label = _ref4.label,
        className = _ref4.className,
        layout = _ref4.layout,
        providedProps = _objectWithoutProperties(_ref4, _excluded3);
      return /*#__PURE__*/_react["default"].createElement(FormItem, {
        label: label,
        className: className,
        layout: layout,
        error: meta.touched && meta.error
      }, /*#__PURE__*/_react["default"].createElement(Component, _extends({}, providedProps, input)));
    }, [])
  }, props));
};
var RFormInputItem = exports.RFormInputItem = function RFormInputItem(_ref5) {
  var Component = _ref5.component,
    size = _ref5.size,
    props = _objectWithoutProperties(_ref5, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    component: (0, _react.useCallback)(function (_ref6) {
      var input = _ref6.input,
        meta = _ref6.meta,
        label = _ref6.label,
        className = _ref6.className,
        layout = _ref6.layout,
        providedProps = _objectWithoutProperties(_ref6, _excluded5);
      return /*#__PURE__*/_react["default"].createElement(FormInputItem, {
        label: label,
        size: size,
        className: className,
        layout: layout,
        error: meta.touched && meta.error
      }, /*#__PURE__*/_react["default"].createElement(Component, _extends({}, providedProps, input)));
    }, [size])
  }, props));
};